import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import DatabaseStorageModal from './DatabaseStorageModal';
import * as FiIcons from 'react-icons/fi';

const { FiDatabase, FiCheck, FiAlertCircle } = FiIcons;

/**
 * Enhanced storage buttons for Supabase database storage
 */
const EnhancedFileStorageButtons = ({ bookmarks, onBookmarksUpdate, bookmarksCount = 0 }) => {
  const [showDatabaseModal, setShowDatabaseModal] = useState(false);
  const [dbStatus, setDbStatus] = useState(null);

  const showStatus = (message, type = 'info') => {
    setDbStatus({ message, type });
    setTimeout(() => setDbStatus(null), 3000);
  };

  return (
    <>
      <div className="flex items-center gap-2">
        {/* Database Storage Button */}
        <div className="relative">
          <button 
            onClick={() => setShowDatabaseModal(true)} 
            className="px-3 py-2 rounded-lg transition-colors flex items-center gap-2 shadow-sm bg-blue-600 text-white hover:bg-blue-700"
            title="Database storage with Supabase"
          >
            <SafeIcon icon={FiDatabase} className="w-4 h-4" />
            <span className="hidden sm:inline">Database</span>
          </button>

          {dbStatus && (
            <div className={`absolute top-full mt-2 left-0 z-10 w-48 p-2 rounded-md text-sm whitespace-nowrap ${
              dbStatus.type === 'success' ? 'bg-green-100 text-green-800' : 
              dbStatus.type === 'error' ? 'bg-red-100 text-red-800' : 
              'bg-blue-100 text-blue-800'
            }`}>
              <div className="flex items-center gap-1">
                <SafeIcon 
                  icon={dbStatus.type === 'success' ? FiCheck : FiAlertCircle} 
                  className={`w-4 h-4 ${
                    dbStatus.type === 'success' ? 'text-green-600' : 'text-red-600'
                  }`} 
                />
                <span>{dbStatus.message}</span>
              </div>
            </div>
          )}
        </div>

        {/* Status Indicator */}
        <div className="flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 rounded text-xs">
          <SafeIcon icon={FiCheck} className="w-3 h-3" />
          <span className="hidden sm:inline">Synced</span>
        </div>
      </div>

      {/* Database Storage Modal */}
      <DatabaseStorageModal 
        isOpen={showDatabaseModal} 
        onClose={() => setShowDatabaseModal(false)} 
        bookmarks={bookmarks} 
        onBookmarksUpdate={onBookmarksUpdate} 
        bookmarksCount={bookmarksCount} 
      />
    </>
  );
};

export default EnhancedFileStorageButtons;